module.exports = __webpack_public_path__ + "media/src/images/businessStats1-21b3297c2b903ea92f7b422c9456be0a.svg";